export default __webpack_public_path__ + "static/about-59a23438596833eb1c8892ec681b9399.png";